module.exports = __webpack_public_path__ + "media/images/admin/icons/crosshair-722ef8db835b506a741de6cc55af6663.svg";